export const passiveSuffixes = [
	"ιόμασταν",
	"ιόσασταν",
	"ούμασταν",
	"ούσασταν",
	"ομασταν",
	"οσασταν",
	"όμασταν",
	"όσασταν",
	"ιόμαστε",
	"ιούνται",
	"ιόσαστε",
	"ηθήκαμε",
	"ηθήκατε",
	"ιούνταν",
	"ούμαστε",
	"θήκαμε",
	"θήκατε",
	"τήκαμε",
	"τήκατε",
	"όμαστε",
	"όσαστε",
	"ηθούμε",
	"ηθείτε",
	"ήθηκες",
	"ήθηκαν",
	"ιόμουν",
	"ιόσουν",
	"ούνται",
	"ούμουν",
	"ούσουν",
	"ούνταν",
	"μαστε",
	"σαστε",
	"θούμε",
	"θείτε",
	"τούμε",
	"τείτε",
	"θηκες",
	"θηκαν",
	"τηκες",
	"τηκαν",
	"ονται",
	"όμουν",
	"όσουν",
	"ονταν",
	"ιέμαι",
	"ιέσαι",
	"ιέται",
	"ιέστε",
	"ηθείς",
	"ηθούν",
	"ήθηκα",
	"ήθηκε",
	"ιόταν",
	"ούμαι",
	"είσαι",
	"είται",
	"είστε",
	"θείς",
	"θούν",
	"τείς",
	"τούν",
	"θηκα",
	"θηκε",
	"τηκα",
	"τηκε",
	"μουν",
	"σουν",
	"νταν",
	"ομαι",
	"εσαι",
	"εται",
	"εστε",
	"όταν",
	"ηθεί",
	"μαι",
	"σαι",
	"ται",
	"στε",
	"θεί",
	"τεί",
	"ταν",
	"ηθώ",
	"θώ",
	"τώ",
];
